import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Trade } from "../_types/trade";

@Injectable({
  providedIn: 'root',
})
export class TradesService extends Service<Trade> {
  public override type = 'trades';
  public override url = 'common/trades';
}
